import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

// project-imports
import SectionTitle from '../sectionTitle/SectionTitle';
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';
import CalendlyPopupButton from '../calendly/CalendlyPopupButton';
import { Link } from 'react-router-dom';

// Reading ENV variables
const NUMBER_OF_COURSES = process.env.REACT_APP_ABOUT_US_NUMBER_OF_COURSES;
const NUMBER_OF_VIDEOS = process.env.REACT_APP_ABOUT_US_NUMBER_OF_YOU_TUBE_VIDEOS;
const ABOUT_US_MAIN_DESCRIPTION = process.env.REACT_APP_ABOUT_US_MAIN_DESCRIPTION;
const GET_FREE_CONSULTATION_BANNER_SMALL_LINK = process.env.REACT_APP_GET_FREE_CONSULTATION_BANNER_SMALL_LINK;
const GET_FREE_CONSULTATION_BANNER_MEDIUM_LINK = process.env.REACT_APP_GET_FREE_CONSULTATION_BANNER_MEDIUM_LINK;
const GET_FREE_CONSULTATION_BANNER_LARGE_LINK = process.env.REACT_APP_GET_FREE_CONSULTATION_BANNER_LARGE_LINK

// Constant features 
const features = [
    {
        icon: 'icon-checkbox-circle-fill-solid',
        title: 'Career Guidance'
    },
    {
        icon: 'icon-checkbox-circle-fill-solid',
        title: 'Administration Help'
    },
    {
        icon: 'icon-checkbox-circle-fill-solid',
        title: 'Doubt Solving'
    },
    {
        icon: 'icon-checkbox-circle-fill-solid',
        title: 'Interview Preparation'
    }
];

const BookConsultationSection = () => {

    // Reading environment variable start
    const YOUTUBE_CHANNEL_URL = process.env.REACT_APP_YOUTUBE_CHANNEL_URL;
    // Reading environment variable end

    return (
        <div className="edu-about-area about-style-3 edu-section-gap bg-image">
            <div className="container eduvibe-animated-shape">
                <div className="row g-5 align-items-center">
                    <div className="col-xl-6 col-lg-6 pr--80">
                        <ScrollAnimation
                            animateIn="fadeIn"
                            animateOut="fadeInOut"
                            className="gappery-wrapper"
                            delay={150}
                            animateOnce={true}
                        >
                            <div className="row g-5 align-items-end">
                                <div className="col-lg-5 col-md-6">
                                    <div className="gallery-image mt--85">
                                        <Link to={GET_FREE_CONSULTATION_BANNER_SMALL_LINK} target="_blank">
                                            <img className="w-100" src="/images/about/about-04/gallery-9.png" alt="Gallery Images" loading='lazy' />
                                        </Link>
                                        {/* <img className="w-100" src="/images/about/about-04/gallery-9.png" alt="Gallery Images" loading='lazy' /> */}
                                        <div className="icon-badge">
                                            <i className="icon-ribbon"></i>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-7 col-md-6">
                                    <div className="gallery-image">
                                        <Link to={GET_FREE_CONSULTATION_BANNER_MEDIUM_LINK} target="_blank">
                                            <img className="w-100" src="/images/about/about-04/gallery-10.png" alt="Gallery Images" />
                                        </Link>
                                        {/* <img className="w-100" src="/images/about/about-04/gallery-10.png" alt="Gallery Images" /> */}
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <div className="gallery-image gallery-image-3 text-center">
                                        <Link to={GET_FREE_CONSULTATION_BANNER_LARGE_LINK} target="_blank">
                                            <img src="/images/about/about-04/gallery-8.png" alt="Gallery Images" />
                                        </Link>
                                        {/* <img src="/images/about/about-04/gallery-8.png" alt="Gallery Images" /> */}

                                        <div className="student-like-status bounce-slide">
                                            <div className="inner">
                                                <div className="icon">
                                                    <i className="icon-Smile"></i>
                                                </div>
                                                <div className="content">
                                                    <h6 className="title">{process.env.REACT_APP_LONGSWITCH_ACADEMY_SUBSCRIBERS}</h6>
                                                    <span className="subtitle">Total Subscribers</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ScrollAnimation>
                    </div>
                    <div className="col-lg-6">
                        <div className="inner  mt_md--40 mt_sm--40">
                            {/* Title section */}
                            <SectionTitle
                                classes="text-start"
                                slogan="Book your free 1:1 Salesforce consultation today"
                                title="Get Personalized Salesforce Career Advice & Real-World Salesforce Guidance"
                            />

                            {/* Descritpion Section */}
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}
                            >
                                <p className="line-before mt--5 mb--5 fs-15">
                                    Longswitch Academy offers free 1:1 Salesforce consultation to help you with Salesforce career advice, Admin & Developer doubts, interview preparation, and project guidance.
                                </p>
                            </ScrollAnimation>
                            {/* Features Section */}
                            <div className="feature-style-2">
                                {(features || []).map((item, i) => (
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        animateOut="fadeInOut"
                                        animateOnce={true}
                                        className="single-feature"
                                        key={i}
                                    >
                                        <div className="icon">
                                            <i className={item?.icon}></i>
                                        </div>
                                        <div className="content">
                                            <h6 className="feature-title">{item?.title}</h6>
                                        </div>
                                    </ScrollAnimation>
                                ))}
                            </div>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                className="read-more-btn mt--60"
                                animateOnce={true}
                            >
                                {/* Book Consultation */}
                                <div className="session space-no-wrap">
                                    <CalendlyPopupButton btnText="Book 1:1 Consultation" color='#F86F03' className='edu-btn subscribe btn-medium' />
                                </div>

                            </ScrollAnimation>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BookConsultationSection;